import { KeyValue } from '@angular/common';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map,Observable } from 'rxjs';

import { IS_API_GATEWAY, IS_PRIVATE_API } from '@personal-area/common';

import { VpsLocation } from '../models/vps-location';
import { VpsServerExtended } from '../models/vps-server';

const vpsURLs = {
  agree: `/v1/vps/conditions`,
  locations: `/v1/vps/locations`,
  startScripts: `/v1/vps/startscripts`,
  server: `/v1/vps/servers`,
  serverData: (serverId: number) => `/v1/vps/servers/${serverId}`,
};

export const DataCenterInvalidArgumentExceptionCode = 313003;

@Injectable()
export class VpsApiService {
  constructor(private _http: HttpClient) { }

  public agree(): Observable<{ serverId: number }> {
    return this._http.post<{ serverId: number }>(
      vpsURLs.agree,
      {},
      {
        context: new HttpContext().set(IS_PRIVATE_API, true).set(IS_API_GATEWAY, true),
      },
    );
  }

  public getServerLocations(): Observable<VpsLocation[]> {
    return this._http
      .get<{ items: VpsLocation[] }>(vpsURLs.locations, {
        context: new HttpContext().set(IS_PRIVATE_API, true).set(IS_API_GATEWAY, true),
      })
      .pipe(map((data) => data.items));
  }

  public getServerStartScripts(): Observable<KeyValue<number, string>[]> {
    return this._http
      .get<{ items: KeyValue<number, string>[] }>(vpsURLs.startScripts, {
        context: new HttpContext().set(IS_PRIVATE_API, true).set(IS_API_GATEWAY, true),
      })
      .pipe(map((data) => data.items));
  }

  public requestServer(
    data: { accountId: number; locationId: number; startUpScriptId: number },
  ) {
    return this._http.post(vpsURLs.server, data, {
      context: new HttpContext().set(IS_PRIVATE_API, true).set(IS_API_GATEWAY, true),
    });
  }

  public updateServer(serverId: number, data: { accountId: number }) {
    return this._http.patch(vpsURLs.serverData(serverId), data, {
      context: new HttpContext().set(IS_PRIVATE_API, true).set(IS_API_GATEWAY, true),
    });
  }

  public getServerInfo(serverId: number): Observable<VpsServerExtended> {
    return this._http.get<VpsServerExtended>(
      vpsURLs.serverData(serverId), {
      context: new HttpContext().set(IS_PRIVATE_API, true).set(IS_API_GATEWAY, true),
    });
  }

  public cancelServer(serverId: number) {
    return this._http.delete(vpsURLs.serverData(serverId), {
      context: new HttpContext().set(IS_PRIVATE_API, true).set(IS_API_GATEWAY, true),
    });
  }
}
